import React from 'react'
import TreatmentUpdate from '../treatment_components/treatmentUpdate'
import WebSidebar from '../../web_sidebar'
export default function
    () {
    return (
        <div>
            <div className='row'>

                <WebSidebar />


                <div className='content-wrapper w-75 bg-white p-5'>
                    <div>
                        <h2>Update Treatment</h2>
                        <TreatmentUpdate />
                    </div>


                </div>
            </div>




        </div>
    )
}
